/**
 * Language Selector - Custom Dropdown Handler
 * Handles language switching via Shopify localization API
 */

(function () {
  "use strict";

  // Wait for DOM to be ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  function init() {
    const languageSelector = document.querySelector(".language-selector");
    if (!languageSelector) return;

    const languageOptions =
      languageSelector.querySelectorAll(".language-option");
    const localizationForm = languageSelector.querySelector(
      "localization-form form"
    );
    const localeInput = localizationForm
      ? localizationForm.querySelector("#locale_code_input")
      : null;

    languageOptions.forEach(function (option) {
      option.addEventListener("click", function (e) {
        e.preventDefault();

        const localeCode = this.getAttribute("data-locale");
        const isCurrent = this.getAttribute("data-current") === "true";

        // Don't reload if clicking current language
        if (isCurrent) {
          return;
        }

        // Update hidden input and submit form
        if (localeInput && localizationForm) {
          localeInput.value = localeCode;

          // Debug: Check form action

          localizationForm.submit();
        }
      });
    });

    // Optional: Close dropdown when clicking outside
    document.addEventListener("click", function (e) {
      if (!languageSelector.contains(e.target)) {
        // Dropdown will close automatically via CSS
      }
    });
  }
})();
